// export const GOOGLE_MAPS_API_KEY = 'AIzaSyDAs0-A3KtxDdKyJEjLEx6YTvW9QCN_4vg';
export const GOOGLE_MAPS_API_KEY = 'AIzaSyDYncwNGEqwMY3CU0IIvuHvAIH-eTM4Aq8';
export const SUPPORT_EMAIL_ADDRESS = 'support@beachnowit.zohodesk.eu';
export const SUPPORT_EMAIL_SUBJECT = 'Richiesta%20di%20assistenza%20da%20Beachnow.it%20Manager';
export const SUPPORT_EMAIL_BODY = '===%20Descrivi%20la%20tua%20richiesta%20sotto%20questa%20riga%20===%0D%0A%0D%0A';
export const DISCOUNT_PERCENTAGES:number[] = [
    10, 20, 30, 40, 50, 60, 70, 80, 90, 100
];
